import { FaGithub, FaLinkedin } from "react-icons/fa";
import { trackExternalLinkClick } from "../services/trackingService";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative flex flex-col">
      <div className="flex justify-center items-center gap-8 mb-6">
        <a
          href="https://www.linkedin.com/in/guido-cohen-semag/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn de Guido Cohen Semag"
          className="inline-block text-base rounded-md p-1 cursor-pointer"
          onClick={() => trackExternalLinkClick("linkedin", "https://www.linkedin.com/in/guido-cohen-semag/")}
        >
          <FaLinkedin className="text-4xl text-foreground hover:text-[#1582C7] cursor-pointer" />
        </a>

        <a
          href="https://www.github.com/guidocohen/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub de Guido Cohen Semag"
          className="inline-block text-base rounded-md p-1 cursor-pointer"
          onClick={() => trackExternalLinkClick("github", "https://www.github.com/guidocohen/")}
        >
          <FaGithub className="text-4xl text-foreground hover:text-[#1582C7] cursor-pointer" />
        </a>
      </div>

      <p className="relative bottom-2 text-center text-md text-foreground">
         Copyright © {currentYear} - Guido Cohen Semag · Ingeniero en Sistemas
      </p>
    </footer>
  );
};

export default Footer;
